export default __webpack_public_path__ + "static/media/ph.b70e266b.svg";